// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../src/assets/fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../src/assets/fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../src/assets/fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fontWeight with 400 */
@font-face {
  font-family: "Inter-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

/* fontWeight with 500 */
@font-face {
  font-family: "Inter-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

/* fontWeight with 600 */
@font-face {
  font-family: "Inter-SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

/* fontWeight with 700 */
@font-face {
  font-family: "Inter-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

:root {
  --white: #ffffff;
  --black: #000000;
  --red: "red";
  --required-red: #ff1818;
  --light-black: #1e1e1e;
  --purple: #7525e8;
  --dark-purple: #2b3674;
  --dark-grey: #707eae;
  --light_grey: #e0e5f2;
  --text-color: #838383;
  --text-color1: #313131;
  --subtitle-color: #323232;

  --active-green-back: #f4fff3;
  --active-green-text: #5f8d4e;
  --inactive-red-back: #ffe2e5;
  --inactive-red-text: #f64e60;

  --field-background: #f4f7fe;
  --disbaled-color: #b5b5c3;
  --table-text-color: #464e5f;
  --icons-color: #575757;
  --background-color1: #e9efff;

  --placeholder-grey: #a3aed0;
  --placehoder-color1: #d9d9d9;
  --placeholder-color2: #d7d7d7;
  --placeholder-color3: #e9edf7;

  --inter-Regular: Inter-Regular;
  --inter-Medium500: Inter-Medium;
  --Inter-SemiBold600: Inter-SemiBold;
  --Inter-Bold700: Inter-Bold;
}

html,
body {
  height: 100%;
  background-color: #f0f0f0;
  margin: 0px;
  padding: 0px;
}

p,
h1,
h2,
h3,
h4,
h5,
h6,
span,
b,
strong,
body {
  margin: 0px !important;
  padding: 0px !important;
}

p a {
  color: var(--purple);
  text-decoration: none;
}

.linkStyle {
  text-decoration: none;
  word-break: break-all;
}

a:hover,
p a:hover {
  color: rgba(117, 37, 232, 0.8);
}

a {
  font-family: var(--Inter-SemiBold600);
  color: var(--purple);
  text-decoration: none;
  cursor: pointer;
}

.reset-cursor {
  cursor: default !important;
}

.left-arrow {
  width: 9px;
  height: 9px;
}

.diabled {
  opacity: 0.7;
}

.btn-close:focus {
  box-shadow: none !important;
}

.content-header {
  width: 100%;
  padding: 0px 18px;
}

.text-style-wrap {
  word-break: break-all;
}

.nodata-found-container {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-family: var(--inter-Medium500);
  font-size: 15px;
  color: var(--disbaled-color);
  height: 500px;
}

.required-Astric {
  color: var(--required-red);
  font-family: var(--inter-Medium500);
  font-size: 14px;
}

/* color classes
 */
.background-purple {
  background-color: var(--purple) !important;
}

/* /dashboard main content wrapper styles */
.dashboard-main-data-wrap {
  border-radius: 20px;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  overflow-x: hidden;
  position: relative;
  margin: auto;
}

.dashboard-main-data-wrap .row {
  height: 100%;
}

.main {
  overflow-x: scroll;
  overflow-y: hidden;
}

@media (max-width:1700px) {
  .main {
    overflow-y: scroll;
  }
}

.main {
  border-radius: 20px;
  background-color: var(--white);
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 21.63px 22px 40px 22px;
  margin-bottom: 63px;
  /* min-height: calc(100% - 195px); */
  height:calc(100vh - 221px);
}

/* Toast classes on the top */

.text-danger {
  color: "red";
}

.text-success {
  color: var(--active-green-text) !important;
}

.toast-cont {
  margin-top: 15px;
  background: var(--field-background);
  border-radius: 15px;
  width: 100%;
  padding: 10px;
  padding-left: 20px;
  font-family: var(--inter-Medium500);
}

.toast-cont>p {
  font-size: 14px;
  font-family: var(--inter-Medium500);
}

.error-message-style-container {
  padding-top: 5px !important;
}

.passShow-eye,
.confirmPassShow-eye {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 37px;
}

/* form related css */
.wrapper {
  height: 100vh;
}

.auth-page-wrapper {
  width: 100%;
  height: 100%;
  background-color: "#fff" !important;
}

.auth-page-wrapper .row {
  height: 100%;
  justify-content: center;
  align-items: center;
}

.auth-page-wrapper .auth-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.auth-page-wrapper .auth-container .auth-col {
  width: 50%;
}

.form-field-container {
  width: 70% !important;
  margin: auto;
  max-width: 410px;
}

.auth-page-wrapper .auth-container>div:nth-child(2) {
  height: 100%;
  background-image: linear-gradient(to bottom, #7525e833, #22a91633);
  border-bottom-left-radius: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {
  width: 360px;
  max-width: 360px;
  height: auto;
  margin: 50px;
}

.auth-page-wrapper .auth-container>div:nth-child(2) .logo-container>img {
  height: 100%;
  width: 100%;
}

/* form related styles global */

.form-control {
  border-radius: 16px !important;
  border: 1px solid var(--light_grey) !important;
  height: 50px !important;
  font-size: 14px !important;
  font-family: var(--inter-Regular);
  color: var(--black) !important;
  transition: none !important;
  box-shadow: none !important;
}

.input-label-style {
  font-family: var(--inter-Medium500);
  font-size: 14px !important;
  color: var(--dark-purple) !important;
  font-style: normal;
  letter-spacing: -0.28px;
  margin-bottom: 13px;
}

/* placeholder color or input*/

.text-area-style {
  padding: 20px;
  color: var(--table-text-color) !important;
}

input#exampleInputPassword::placeholder,
input#exampleInputEmail1::placeholder,
input#exampleInputName::placeholder {
  color: var(--placeholder-grey);
  font-size: 16px !important;
}

textarea::placeholder {
  color: var(--placeholder-grey) !important;
  font-size: 16px !important;
  font-family: var(--inter-Regular);
}

input.placeholder-style::placeholder {
  color: var(--placeholder-grey) !important;
  font-size: 16px !important;
}

input.form-control:focus {
  border: 1px solid var(--purple) !important;
}

.form-control-icon-space {
  padding-right: 48px !important;
}

.forminut-passeye,
.form-group.forminut-confirmPassShow {
  position: relative;
  margin-bottom: 24px;
}

.auth-page-title {
  color: var(--purple);
  font-family: var(--Inter-Bold700);
  font-size: 36px;
  line-height: 40px;
  letter-spacing: -0.72px;
}

.auth-page-subtitle {
  color: var(--placeholder-grey);
  font-family: var(--inter-Regular);
  font-size: 16px;
  letter-spacing: -0.32px;
}

.fields-container {
  margin-top: 41px;
}

/* simple Button style */

.simplebuttonStyle {
  display: flex !important;
  height: 54px !important;
  padding: 10px 8px !important;
  justify-content: center;
  align-items: center;
  border-radius: 16px !important;
  border: none !important;
  font-family: var(--Inter-Bold700) !important;
  letter-spacing: -0.28px;
  font-size: 14px !important;
}

/* dashboar layout container styles */

.main-container {
  width: 100%;
  height: 100vh;
}

#second-container-wrap {
  width: 100%;
  height: 100vh;
  background-color: var(--field-background);
  position: relative;
  overflow: scroll;
  overflow-x: hidden;
  padding: 14px;
}

.main-container .main-sub-container {
  display: flex;
  flex-direction: row;
  margin: 0px;
  position: relative;
}

.hamburger-menu {
  display: none;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 45px;
  background-color: #fff;
  z-index: 12;
  text-align: left;
  border-bottom: 1px solid var(--field-background);
}

.hamburger-menu svg {
  height: 25px;
  width: 25px;
  margin: 10px 0px 5px 14px;
}

.showSidebar {
  display: block !important;
}

/* .header {
    display: flex;
    flex-direction: row;
    padding: 0px 18px;
    padding-top: 45px;
    padding-bottom: 19px;
    justify-content: space-between;
    background-color: var(--field-background);
    z-index: 10;
    top: 0;
    right: 0;
    width: 100%;
}


.profile-toast>p,
.header .left-box>p:nth-child(1) {
    color: var(--dark-grey);
    font-family: var(--inter-Medium500);
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
}

.header .left-box>p:nth-child(2) {
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
    font-size: 34px;
    line-height: 42px;
    letter-spacing: -0.68px;
}

.header .right-box {
    display: flex;
    flex-direction: row;
    align-items: center
}

.header .right-box>div {
    width: 41px;
    height: 41px;
    background-color: var(--white);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.header .right-box>div:nth-child(2) {
    margin-left: 12px;
    position: relative;
}

.profile-toast {
    position: absolute;
    top: 46px;
    right: 0px;
    padding: 15px;
    border-radius: 10px;
    background-color: var(--white);
    width: 150px;
    z-index: 11;
    border: 1px solid var(--field-background);
} */

.status-toast {
  top: 20px;
  width: 90px;
  left: 0px;
}

.profile-toast>p:hover {
  color: var(--light-black);
  cursor: pointer;
}

/* custom table styles */
.table-wrapper-container {}

.table-container {
  padding-right: 2px !important;
}

.divTable {
  display: table;
  width: auto;
  border-spacing: 5px;
  width: 100%;
}

.divTable .headRow {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background: var(--field-background);
  padding: 14px 24px;
  margin-right: 2px !important;
}

.divTable .headRow .divCell {
  color: var(--dark-grey);
  font-family: var(--Inter-SemiBold600);
  font-size: 12px;
  line-height: normal;
  letter-spacing: 0.36px;
}

.divTable .headRow .divCell:nth-child(1),
.divTable .headRow .divCell:nth-child(3) {
  width: 200px;
}

.divTable .headRow .divCell:nth-child(2),
.divTable .headRow .divCell:nth-child(4) {
  width: 180px;
}

.css-1xc3v61-indicatorContainer {
  display: none !important;
}

.css-15lsz6c-indicatorContainer {
  display: none !important;
}

.divTable .headRow .divCell:nth-child(5) {
  width: 160px;
  position: relative;
  cursor: pointer;
}

.divRow {
  display: flex;
  width: 100%;
  width: auto;
  padding: 9px 22px;
  margin: 30px 0px;
  justify-content: space-between;
}

.divRow:hover {
  background: var(--field-background);
}

.divCell {
  min-width: 100px;
}

.divRow .divCell {
  color: var(--table-text-color);
  font-family: var(--Inter-SemiBold600);
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0.36px;
  align-self: center;
  word-break: break-all;
  margin-right: 5px;
}

.divRow .divCell .delete {
  width: 14px;
  height: 16px;
  cursor: pointer;
}

.divCell .divCell .delete:hover {
  cursor: pointer;
  background-color: var(--disbaled-color);
}

.divRow .divCell:nth-child(1) {
  width: 200px;
}

.divTable .headRow .divCell:nth-child(3),
.divRow .divCell:nth-child(3) {
  width: 240px;
}

.divRow .divCell:nth-child(2),
.divRow .divCell:nth-child(4) {
  width: 180px;
}

.divRow .divCell:nth-child(5) {
  width: 160px;
}

.divRow .divCell:nth-child(2) {
  color: var(--disbaled-color);
  font-size: 13px;
}

.divRow .divCell:nth-child(6) {
  display: flex;

  padding-right: 10px;
}

.divTable .headRow .divCell:nth-child(8),
.divRow .divCell:nth-child(8) {
  min-width: 50px !important;
  text-align: center;
}

.divRow .divCell:nth-child(5) button {
  width: 89px !important;
}

.divRow .divCell:nth-child(6) button,
.divRow .divCell:nth-child(8) button {
  width: 98px !important;
}

.upWard {
  margin-left: 5px;
  transform: rotate(-90deg);
}

.downWard {
  margin-left: 5px;
  transform: rotate(90deg);
}

.buttonAcive {
  color: var(--active-green-text) !important;
  background-color: var(--active-green-back) !important;
  /* font-family: Inter; */
  font-size: 11px !important;
  height: 26px !important;
  padding: 6px 12px !important;
  font-family: va(--inter-Medium500) !important;
  border-radius: 6px !important;
}

.buttonInactive {
  color: var(--inactive-red-text) !important;
  background-color: var(--inactive-red-back) !important;
  font-size: 11px !important;
  height: 26px !important;
  padding: 6px 12px !important;
  font-family: va(--inter-Medium500) !important;
  border-radius: 6px !important;
}

.inActiveButton {
  color: var(--placeholder-grey) !important;
  background-color: var(--field-background) !important;
  font-size: 11px !important;
  height: 26px !important;
  padding: 6px 12px !important;
  font-family: va(--inter-Medium500) !important;
  border-radius: 6px !important;
  padding-left: 0px !important;
}

.outlineButton {
  color: var(--black) !important;
  background-color: var(--white) !important;
  border: 1px solid var(--background-color1) !important;
  font-family: var(--Inter-SemiBold600) !important;
  font-size: 10px !important;
  height: 26px !important;
  padding: 10px 10px !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  height: 32px !important;
}

.deleteButton {
  color: var(--black) !important;
  background-color: var(--field-background) !important;
  border: 1px solid var(--background-color1) !important;
  font-family: var(--Inter-SemiBold600) !important;
  font-size: 10px !important;
  height: 26px !important;
  padding: 10px 10px !important;
  border-radius: 6px !important;
  text-transform: uppercase !important;
  height: 32px !important;
}

.outlineButton:hover {
  background-color: var(--field-background) !important;
}

.deleteButton:hover {
  background-color: var(--white) !important;
}

/* client table styling */

.divTable.client-table .divCell {
  min-width: 50px !important;
}

.divTable.client-table .headRow {
  justify-content: space-between;
}

.divTable.client-table .headRow .divCell {
  margin-right: 5px;
}

.divTable.client-table .divRow .divCell:nth-child(1),
.divTable.client-table .headRow .divCell:nth-child(1) {
  width: 160px;
  flex-grow: 0.2;
}

.divTable.client-table .divRow .divCell:nth-child(3),
.divTable.client-table .headRow .divCell:nth-child(3) {
  width: 230px;
  padding-right: 15px !important;
  flex-grow: 0.2;
}

.divTable.client-table .divRow .divCell:nth-child(2),
.divTable.client-table .headRow .divCell:nth-child(2) {
  width: 100px;
}

.divTable.client-table .divRow .divCell:nth-child(4),
.divTable.client-table .headRow .divCell:nth-child(4) {
  width: 120px;
}

.divTable.client-table .divRow .divCell:nth-child(5),
.divTable.client-table .headRow .divCell:nth-child(5) {
  width: 100px;
}

.divTable.client-table .divRow .divCell:nth-child(7),
.divTable.client-table .headRow .divCell:nth-child(7) {
  width: 200px;
}

.divTable.client-table .divRow .divCell:nth-child(6),
.divTable.client-table .divRow .divCell:nth-child(7),
.divTable.client-table .divRow .divCell:nth-child(8) {
  font-size: 10px !important;
  padding-right: 0px !important;
}

.divTable.client-table .divRow .divCell:nth-child(6),
.divTable.client-table .divRow .divCell:nth-child(8),
.divTable.client-table .headRow .divCell:nth-child(6),
.divTable.client-table .headRow .divCell:nth-child(8) {
  width: 194px;
  text-align: left;
}

.divTable.client-table .headRow .divCell:nth-child(9),
.divTable.client-table .divRow .divCell:nth-child(9) {
  width: 100px;
  text-align: left;
}

.request-status-Container {
  position: relative;
  display: flex;
  flex-direction: row;
}

.divTable.client-table .divRow .divCell:nth-child(10) {
  margin-right: 0px;
  text-align: center;
  padding: 8px 0px;
}

.divTable.client-table .divRow .divCell:nth-child(10):hover {
  cursor: pointer;
}

.divTable.client-table .divRow .divCell:nth-child(6):focus {
  cursor: pointer;
}

.divTable.client-table .divRow {
  padding: 8.5px 22px !important;
}

.divTable.client-table .divRow:hover {
  cursor: pointer;
}

.css-3iigni-container,
.divCell .css-b62m3t-container {
  width: 100%;
}

.divTable.client-table .divRow .divCell .css-3iigni-container,
.divTable.client-table .divRow .divCell .css-b62m3t-container {
  /* height: 32px !important; */
}

/* .divTable.client-table .divRow .divCell  div {
    height: 32px !important;
} */

.css-n3rqp9-control,
.css-1yhe670-control {
  min-height: 30px !important;
}

.css-tj5bde-Svg {
  fill: var(--purple) !important;
  height: 15px !important;
  width: 15px !important;
}

.divCell .css-b62m3t-container .css-9e39r0-control {
  border: none !important;
  border-radius: 6px !important;
  cursor: pointer;
}

.css-1u9des2-indicatorSeparator {
  background-color: transparent !important;
}

.placeHolderStyle {
  font-size: 12px !important;
  color: var(--placeholder-grey) !important;
  font-family: var(--inter-Regular);
}

.request-status-dropdown-container {
  position: relative;
  border: 1px solid #cccccc;
  border-radius: 4px;
}

.request-status-dropdown-container img {
  position: absolute;
  top: 8px;
  right: 9px;
}

.request-status-toast {
  top: 28px !important;
  width: 100px !important;
}

/* page not found styles**** */

.dashboardContent.error-template .row {
  background: var(--light-brown) !important;
  height: 100vh;
  padding: 0px !important;
  margin: 0px !important;
  width: 100%;
  justify-content: center;
}

.region.region-content {
  height: auto;
  text-align: center;
  box-shadow: 5px 7px 20px 0px #cccc;
  margin: 4% 0px;
  background: #ffffff54;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dashboardContent.error-template img {
  object-fit: scale-down;
  width: 40%;
}

.dashboardContent.error-template .row .title {
  color: var(--light-black);
  font-family: var(--Inter-Bold700);
  font-size: 34px;
  line-height: 42px;
  letter-spacing: -0.68px;
}

.content {
  color: var(--table-text-color);
  font-family: var(--Inter-SemiBold600);
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0.36px;
  align-self: center;
  word-break: break-all;
  margin-right: 5px;
  margin-top: 10px !important;
}

.dashboardContent.error-template .content.continue-program-text {
  color: var(--purple);
  text-decoration: none;
  text-decoration: none;
  word-break: break-all;
  cursor: pointer;
}

.dashboardContent.error-template .content.continue-program-text:hover {
  opacity: 0.8;
}

.divTable.manage-video-table .divCell {
  word-break: break-word;
  white-space: wrap;
}

.divTable.manage-video-table .divRow .divCell {
  align-self: start;
}

.table-wrapper-container {
  overflow-x: scroll;
  max-width: 100%;
  white-space: nowrap;
  z-index: 9;
  box-sizing: content-box;
  scrollbar-width: thin;
  scrollbar-color: #888 #f0f0f0;
}

.table-wrapper-container::-webkit-scrollbar,
.table-wrapper-container::-moz-scrollbar {
  height: 8px;
  border-radius: 10px;
  background-color: #f1f1f1;
}

.table-wrapper-container::-webkit-scrollbar-thumb,
.table-wrapper-container::-moz-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.table-wrapper-container::-webkit-scrollbar-thumb:hover,
.table-wrapper-container::-moz-scrollbar-thumb:hover {
  background: #555;
}

/* MEDIA QUERIES */
@media (max-width: 1700px) {}

@media (max-width: 768px) {
  .main-container .main-sub-container .first-container-wrap {
    display: none;
    position: absolute;
    top: 45px;
    left: 0px;
    width: 18.125rem;
    z-index: 1001;
    background-color: rgba(0, 0, 0, 0.1);
    width: 100%;
  }

  .main-container .main-sub-container .first-container-wrap #sidebar {
    height: calc(100vh - 45px) !important;
  }

  .hamburger-menu {
    display: block;
    z-index: 1001;
  }

  .main {
    padding: 22px;
  }

  .footer-container {
    width: 100% !important;
    padding-right: 14px !important;
  }

  .auth-page-title,
  .header .left-box>p:nth-child(2) {
    font-size: 29px;
    line-height: 29px;
  }

  .form-field-container {
    width: 80% !important;
    max-width: none;
    padding-top: 40px !important;
  }

  .auth-page-wrapper .auth-container {
    display: flex;
    flex-direction: column-reverse !important;
    justify-content: flex-end;
  }

  .auth-page-wrapper .auth-container .auth-col {
    width: 100%;
  }

  .auth-page-wrapper .auth-container .auth-col-2 {
    width: 100%;
    padding-bottom: 80px;
  }

  .auth-page-wrapper .auth-container>div:nth-child(2) {
    height: auto !important;
    border-bottom-left-radius: 50px;
  }

  .auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {
    width: 250px;
    max-width: 250px;
    height: auto;
    margin: 35px;
  }

  .auth-container .auth-col .form-field-container {
    width: 100% !important;
    padding: 20px;
  }

  .wrapper {
    height: auto !important;
  }

  .App {
    height: 100%;
    background: white;
  }
}

@media (max-width: 440px) {
  .header {
    flex-direction: column !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .header .left-box {
    margin-bottom: 19px;
  }

  .auth-page-title,
  .header .left-box>p:nth-child(2) {
    font-size: 25px;
    line-height: 25px;
  }

  .main {
    padding: 16px;
  }

  .coach-header .left-box>p:nth-child(1) {
    font-size: 19px !important;
    line-height: 19px !important;
  }

  .header .right-box {
    justify-content: flex-end;
  }

  .paginatino-button {
    display: none;
  }

  .modal-footer button,
  .options-container .deleteButton {
    width: 100% !important;
  }

  .form-field-container {
    width: 100% !important;
    margin-bottom: 20px;
  }

  .auth-container .auth-col .form-field-container {
    width: 100% !important;
    padding: 20px 15px;
    padding-bottom: 0px;
  }

  .auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {
    width: 200px;
    max-width: 200px;
    height: auto;
    margin: 50px;
  }

  #second-container-wrap .header .left-box {
    margin-bottom: 0px !important;
  }

  #second-container-wrap .header .right-box {
    position: fixed;
    top: 3px;
    right: 12px;
    z-index: 22;
  }

  #second-container-wrap .header.coach-header .right-box {
    position: relative;
    margin-top: 15px;
    right: 0px !important;
  }

  #sidebar {
    width: 16rem !important;
  }

  #sidebar>* {
    padding-left: 1rem !important;
  }

  .dashboardContent.error-template .col-lg-3 {
    display: none;
  }

  .dashboardContent.error-template img {
    width: 60%;
  }

  .dashboardContent.error-template .col-lg-6.region.region-content {
    margin: 25px;
    /* height: auto !important; */
  }
}

/* modal width media Queries */

@media (min-width: 768px) {

  .modal-lg,
  .modal-xl {
    --bs-modal-width: 700px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/GlobalStyles.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,4BAA4B;EAC5B,+DAAuE;AACzE;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,+DAAsE;AACxE;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,+DAAwE;AAC1E;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,+DAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;;EAEzB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;;EAE7B,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;EAWE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE;AACF;EACE,0CAA0C;AAC5C;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,6BAA6B;;AAE7B;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kEAAkE;EAClE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,+BAA+B;;AAE/B;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;;;EAGE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;;AAExB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,qCAAqC;;AAErC;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+DG;;AAEH;EACE,SAAS;EACT,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wBAAwB;AACxB,0BAA0B;;AAE1B;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;;EAEb,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;EACrD,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;EACrD,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,6CAA6C;EAC7C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,qDAAqD;EACrD,gDAAgD;EAChD,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,qDAAqD;EACrD,gDAAgD;EAChD,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yBAAyB;;AAEzB;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,8BAA8B;;AAE9B;EACE,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB,4BAA4B;;AAE5B;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,yCAAyC;IACzC,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;AACF;;AAEA,8BAA8B;;AAE9B;;EAEE;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":["/* fontWeight with 400 */\n@font-face {\n  font-family: \"Inter-Regular\";\n  src: url(\"../../src/assets/fonts/Inter-Regular.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 500 */\n@font-face {\n  font-family: \"Inter-Medium\";\n  src: url(\"../../src/assets/fonts/Inter-Medium.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 600 */\n@font-face {\n  font-family: \"Inter-SemiBold\";\n  src: url(\"../../src/assets/fonts/Inter-SemiBold.ttf\") format(\"truetype\");\n}\n\n/* fontWeight with 700 */\n@font-face {\n  font-family: \"Inter-Bold\";\n  src: url(\"../../src/assets/fonts/Inter-Bold.ttf\") format(\"truetype\");\n}\n\n:root {\n  --white: #ffffff;\n  --black: #000000;\n  --red: \"red\";\n  --required-red: #ff1818;\n  --light-black: #1e1e1e;\n  --purple: #7525e8;\n  --dark-purple: #2b3674;\n  --dark-grey: #707eae;\n  --light_grey: #e0e5f2;\n  --text-color: #838383;\n  --text-color1: #313131;\n  --subtitle-color: #323232;\n\n  --active-green-back: #f4fff3;\n  --active-green-text: #5f8d4e;\n  --inactive-red-back: #ffe2e5;\n  --inactive-red-text: #f64e60;\n\n  --field-background: #f4f7fe;\n  --disbaled-color: #b5b5c3;\n  --table-text-color: #464e5f;\n  --icons-color: #575757;\n  --background-color1: #e9efff;\n\n  --placeholder-grey: #a3aed0;\n  --placehoder-color1: #d9d9d9;\n  --placeholder-color2: #d7d7d7;\n  --placeholder-color3: #e9edf7;\n\n  --inter-Regular: Inter-Regular;\n  --inter-Medium500: Inter-Medium;\n  --Inter-SemiBold600: Inter-SemiBold;\n  --Inter-Bold700: Inter-Bold;\n}\n\nhtml,\nbody {\n  height: 100%;\n  background-color: #f0f0f0;\n  margin: 0px;\n  padding: 0px;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nspan,\nb,\nstrong,\nbody {\n  margin: 0px !important;\n  padding: 0px !important;\n}\n\np a {\n  color: var(--purple);\n  text-decoration: none;\n}\n\n.linkStyle {\n  text-decoration: none;\n  word-break: break-all;\n}\n\na:hover,\np a:hover {\n  color: rgba(117, 37, 232, 0.8);\n}\n\na {\n  font-family: var(--Inter-SemiBold600);\n  color: var(--purple);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.reset-cursor {\n  cursor: default !important;\n}\n\n.left-arrow {\n  width: 9px;\n  height: 9px;\n}\n\n.diabled {\n  opacity: 0.7;\n}\n\n.btn-close:focus {\n  box-shadow: none !important;\n}\n\n.content-header {\n  width: 100%;\n  padding: 0px 18px;\n}\n\n.text-style-wrap {\n  word-break: break-all;\n}\n\n.nodata-found-container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  font-family: var(--inter-Medium500);\n  font-size: 15px;\n  color: var(--disbaled-color);\n  height: 500px;\n}\n\n.required-Astric {\n  color: var(--required-red);\n  font-family: var(--inter-Medium500);\n  font-size: 14px;\n}\n\n/* color classes\n */\n.background-purple {\n  background-color: var(--purple) !important;\n}\n\n/* /dashboard main content wrapper styles */\n.dashboard-main-data-wrap {\n  border-radius: 20px;\n  width: 100%;\n  height: 100%;\n  background-color: var(--white);\n  overflow-x: hidden;\n  position: relative;\n  margin: auto;\n}\n\n.dashboard-main-data-wrap .row {\n  height: 100%;\n}\n\n.main {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n\n@media (max-width:1700px) {\n  .main {\n    overflow-y: scroll;\n  }\n}\n\n.main {\n  border-radius: 20px;\n  background-color: var(--white);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 21.63px 22px 40px 22px;\n  margin-bottom: 63px;\n  /* min-height: calc(100% - 195px); */\n  height:calc(100vh - 221px);\n}\n\n/* Toast classes on the top */\n\n.text-danger {\n  color: \"red\";\n}\n\n.text-success {\n  color: var(--active-green-text) !important;\n}\n\n.toast-cont {\n  margin-top: 15px;\n  background: var(--field-background);\n  border-radius: 15px;\n  width: 100%;\n  padding: 10px;\n  padding-left: 20px;\n  font-family: var(--inter-Medium500);\n}\n\n.toast-cont>p {\n  font-size: 14px;\n  font-family: var(--inter-Medium500);\n}\n\n.error-message-style-container {\n  padding-top: 5px !important;\n}\n\n.passShow-eye,\n.confirmPassShow-eye {\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  top: 37px;\n}\n\n/* form related css */\n.wrapper {\n  height: 100vh;\n}\n\n.auth-page-wrapper {\n  width: 100%;\n  height: 100%;\n  background-color: \"#fff\" !important;\n}\n\n.auth-page-wrapper .row {\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.auth-page-wrapper .auth-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.auth-page-wrapper .auth-container .auth-col {\n  width: 50%;\n}\n\n.form-field-container {\n  width: 70% !important;\n  margin: auto;\n  max-width: 410px;\n}\n\n.auth-page-wrapper .auth-container>div:nth-child(2) {\n  height: 100%;\n  background-image: linear-gradient(to bottom, #7525e833, #22a91633);\n  border-bottom-left-radius: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {\n  width: 360px;\n  max-width: 360px;\n  height: auto;\n  margin: 50px;\n}\n\n.auth-page-wrapper .auth-container>div:nth-child(2) .logo-container>img {\n  height: 100%;\n  width: 100%;\n}\n\n/* form related styles global */\n\n.form-control {\n  border-radius: 16px !important;\n  border: 1px solid var(--light_grey) !important;\n  height: 50px !important;\n  font-size: 14px !important;\n  font-family: var(--inter-Regular);\n  color: var(--black) !important;\n  transition: none !important;\n  box-shadow: none !important;\n}\n\n.input-label-style {\n  font-family: var(--inter-Medium500);\n  font-size: 14px !important;\n  color: var(--dark-purple) !important;\n  font-style: normal;\n  letter-spacing: -0.28px;\n  margin-bottom: 13px;\n}\n\n/* placeholder color or input*/\n\n.text-area-style {\n  padding: 20px;\n  color: var(--table-text-color) !important;\n}\n\ninput#exampleInputPassword::placeholder,\ninput#exampleInputEmail1::placeholder,\ninput#exampleInputName::placeholder {\n  color: var(--placeholder-grey);\n  font-size: 16px !important;\n}\n\ntextarea::placeholder {\n  color: var(--placeholder-grey) !important;\n  font-size: 16px !important;\n  font-family: var(--inter-Regular);\n}\n\ninput.placeholder-style::placeholder {\n  color: var(--placeholder-grey) !important;\n  font-size: 16px !important;\n}\n\ninput.form-control:focus {\n  border: 1px solid var(--purple) !important;\n}\n\n.form-control-icon-space {\n  padding-right: 48px !important;\n}\n\n.forminut-passeye,\n.form-group.forminut-confirmPassShow {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.auth-page-title {\n  color: var(--purple);\n  font-family: var(--Inter-Bold700);\n  font-size: 36px;\n  line-height: 40px;\n  letter-spacing: -0.72px;\n}\n\n.auth-page-subtitle {\n  color: var(--placeholder-grey);\n  font-family: var(--inter-Regular);\n  font-size: 16px;\n  letter-spacing: -0.32px;\n}\n\n.fields-container {\n  margin-top: 41px;\n}\n\n/* simple Button style */\n\n.simplebuttonStyle {\n  display: flex !important;\n  height: 54px !important;\n  padding: 10px 8px !important;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px !important;\n  border: none !important;\n  font-family: var(--Inter-Bold700) !important;\n  letter-spacing: -0.28px;\n  font-size: 14px !important;\n}\n\n/* dashboar layout container styles */\n\n.main-container {\n  width: 100%;\n  height: 100vh;\n}\n\n#second-container-wrap {\n  width: 100%;\n  height: 100vh;\n  background-color: var(--field-background);\n  position: relative;\n  overflow: scroll;\n  overflow-x: hidden;\n  padding: 14px;\n}\n\n.main-container .main-sub-container {\n  display: flex;\n  flex-direction: row;\n  margin: 0px;\n  position: relative;\n}\n\n.hamburger-menu {\n  display: none;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 45px;\n  background-color: #fff;\n  z-index: 12;\n  text-align: left;\n  border-bottom: 1px solid var(--field-background);\n}\n\n.hamburger-menu svg {\n  height: 25px;\n  width: 25px;\n  margin: 10px 0px 5px 14px;\n}\n\n.showSidebar {\n  display: block !important;\n}\n\n/* .header {\n    display: flex;\n    flex-direction: row;\n    padding: 0px 18px;\n    padding-top: 45px;\n    padding-bottom: 19px;\n    justify-content: space-between;\n    background-color: var(--field-background);\n    z-index: 10;\n    top: 0;\n    right: 0;\n    width: 100%;\n}\n\n\n.profile-toast>p,\n.header .left-box>p:nth-child(1) {\n    color: var(--dark-grey);\n    font-family: var(--inter-Medium500);\n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 12px;\n}\n\n.header .left-box>p:nth-child(2) {\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n    font-size: 34px;\n    line-height: 42px;\n    letter-spacing: -0.68px;\n}\n\n.header .right-box {\n    display: flex;\n    flex-direction: row;\n    align-items: center\n}\n\n.header .right-box>div {\n    width: 41px;\n    height: 41px;\n    background-color: var(--white);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.header .right-box>div:nth-child(2) {\n    margin-left: 12px;\n    position: relative;\n}\n\n.profile-toast {\n    position: absolute;\n    top: 46px;\n    right: 0px;\n    padding: 15px;\n    border-radius: 10px;\n    background-color: var(--white);\n    width: 150px;\n    z-index: 11;\n    border: 1px solid var(--field-background);\n} */\n\n.status-toast {\n  top: 20px;\n  width: 90px;\n  left: 0px;\n}\n\n.profile-toast>p:hover {\n  color: var(--light-black);\n  cursor: pointer;\n}\n\n/* custom table styles */\n.table-wrapper-container {}\n\n.table-container {\n  padding-right: 2px !important;\n}\n\n.divTable {\n  display: table;\n  width: auto;\n  border-spacing: 5px;\n  width: 100%;\n}\n\n.divTable .headRow {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  border-radius: 6px;\n  background: var(--field-background);\n  padding: 14px 24px;\n  margin-right: 2px !important;\n}\n\n.divTable .headRow .divCell {\n  color: var(--dark-grey);\n  font-family: var(--Inter-SemiBold600);\n  font-size: 12px;\n  line-height: normal;\n  letter-spacing: 0.36px;\n}\n\n.divTable .headRow .divCell:nth-child(1),\n.divTable .headRow .divCell:nth-child(3) {\n  width: 200px;\n}\n\n.divTable .headRow .divCell:nth-child(2),\n.divTable .headRow .divCell:nth-child(4) {\n  width: 180px;\n}\n\n.css-1xc3v61-indicatorContainer {\n  display: none !important;\n}\n\n.css-15lsz6c-indicatorContainer {\n  display: none !important;\n}\n\n.divTable .headRow .divCell:nth-child(5) {\n  width: 160px;\n  position: relative;\n  cursor: pointer;\n}\n\n.divRow {\n  display: flex;\n  width: 100%;\n  width: auto;\n  padding: 9px 22px;\n  margin: 30px 0px;\n  justify-content: space-between;\n}\n\n.divRow:hover {\n  background: var(--field-background);\n}\n\n.divCell {\n  min-width: 100px;\n}\n\n.divRow .divCell {\n  color: var(--table-text-color);\n  font-family: var(--Inter-SemiBold600);\n  font-size: 14px;\n  line-height: normal;\n  letter-spacing: 0.36px;\n  align-self: center;\n  word-break: break-all;\n  margin-right: 5px;\n}\n\n.divRow .divCell .delete {\n  width: 14px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.divCell .divCell .delete:hover {\n  cursor: pointer;\n  background-color: var(--disbaled-color);\n}\n\n.divRow .divCell:nth-child(1) {\n  width: 200px;\n}\n\n.divTable .headRow .divCell:nth-child(3),\n.divRow .divCell:nth-child(3) {\n  width: 240px;\n}\n\n.divRow .divCell:nth-child(2),\n.divRow .divCell:nth-child(4) {\n  width: 180px;\n}\n\n.divRow .divCell:nth-child(5) {\n  width: 160px;\n}\n\n.divRow .divCell:nth-child(2) {\n  color: var(--disbaled-color);\n  font-size: 13px;\n}\n\n.divRow .divCell:nth-child(6) {\n  display: flex;\n\n  padding-right: 10px;\n}\n\n.divTable .headRow .divCell:nth-child(8),\n.divRow .divCell:nth-child(8) {\n  min-width: 50px !important;\n  text-align: center;\n}\n\n.divRow .divCell:nth-child(5) button {\n  width: 89px !important;\n}\n\n.divRow .divCell:nth-child(6) button,\n.divRow .divCell:nth-child(8) button {\n  width: 98px !important;\n}\n\n.upWard {\n  margin-left: 5px;\n  transform: rotate(-90deg);\n}\n\n.downWard {\n  margin-left: 5px;\n  transform: rotate(90deg);\n}\n\n.buttonAcive {\n  color: var(--active-green-text) !important;\n  background-color: var(--active-green-back) !important;\n  /* font-family: Inter; */\n  font-size: 11px !important;\n  height: 26px !important;\n  padding: 6px 12px !important;\n  font-family: va(--inter-Medium500) !important;\n  border-radius: 6px !important;\n}\n\n.buttonInactive {\n  color: var(--inactive-red-text) !important;\n  background-color: var(--inactive-red-back) !important;\n  font-size: 11px !important;\n  height: 26px !important;\n  padding: 6px 12px !important;\n  font-family: va(--inter-Medium500) !important;\n  border-radius: 6px !important;\n}\n\n.inActiveButton {\n  color: var(--placeholder-grey) !important;\n  background-color: var(--field-background) !important;\n  font-size: 11px !important;\n  height: 26px !important;\n  padding: 6px 12px !important;\n  font-family: va(--inter-Medium500) !important;\n  border-radius: 6px !important;\n  padding-left: 0px !important;\n}\n\n.outlineButton {\n  color: var(--black) !important;\n  background-color: var(--white) !important;\n  border: 1px solid var(--background-color1) !important;\n  font-family: var(--Inter-SemiBold600) !important;\n  font-size: 10px !important;\n  height: 26px !important;\n  padding: 10px 10px !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  height: 32px !important;\n}\n\n.deleteButton {\n  color: var(--black) !important;\n  background-color: var(--field-background) !important;\n  border: 1px solid var(--background-color1) !important;\n  font-family: var(--Inter-SemiBold600) !important;\n  font-size: 10px !important;\n  height: 26px !important;\n  padding: 10px 10px !important;\n  border-radius: 6px !important;\n  text-transform: uppercase !important;\n  height: 32px !important;\n}\n\n.outlineButton:hover {\n  background-color: var(--field-background) !important;\n}\n\n.deleteButton:hover {\n  background-color: var(--white) !important;\n}\n\n/* client table styling */\n\n.divTable.client-table .divCell {\n  min-width: 50px !important;\n}\n\n.divTable.client-table .headRow {\n  justify-content: space-between;\n}\n\n.divTable.client-table .headRow .divCell {\n  margin-right: 5px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(1),\n.divTable.client-table .headRow .divCell:nth-child(1) {\n  width: 160px;\n  flex-grow: 0.2;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(3),\n.divTable.client-table .headRow .divCell:nth-child(3) {\n  width: 230px;\n  padding-right: 15px !important;\n  flex-grow: 0.2;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(2),\n.divTable.client-table .headRow .divCell:nth-child(2) {\n  width: 100px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(4),\n.divTable.client-table .headRow .divCell:nth-child(4) {\n  width: 120px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(5),\n.divTable.client-table .headRow .divCell:nth-child(5) {\n  width: 100px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(7),\n.divTable.client-table .headRow .divCell:nth-child(7) {\n  width: 200px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(6),\n.divTable.client-table .divRow .divCell:nth-child(7),\n.divTable.client-table .divRow .divCell:nth-child(8) {\n  font-size: 10px !important;\n  padding-right: 0px !important;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(6),\n.divTable.client-table .divRow .divCell:nth-child(8),\n.divTable.client-table .headRow .divCell:nth-child(6),\n.divTable.client-table .headRow .divCell:nth-child(8) {\n  width: 194px;\n  text-align: left;\n}\n\n.divTable.client-table .headRow .divCell:nth-child(9),\n.divTable.client-table .divRow .divCell:nth-child(9) {\n  width: 100px;\n  text-align: left;\n}\n\n.request-status-Container {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(10) {\n  margin-right: 0px;\n  text-align: center;\n  padding: 8px 0px;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(10):hover {\n  cursor: pointer;\n}\n\n.divTable.client-table .divRow .divCell:nth-child(6):focus {\n  cursor: pointer;\n}\n\n.divTable.client-table .divRow {\n  padding: 8.5px 22px !important;\n}\n\n.divTable.client-table .divRow:hover {\n  cursor: pointer;\n}\n\n.css-3iigni-container,\n.divCell .css-b62m3t-container {\n  width: 100%;\n}\n\n.divTable.client-table .divRow .divCell .css-3iigni-container,\n.divTable.client-table .divRow .divCell .css-b62m3t-container {\n  /* height: 32px !important; */\n}\n\n/* .divTable.client-table .divRow .divCell  div {\n    height: 32px !important;\n} */\n\n.css-n3rqp9-control,\n.css-1yhe670-control {\n  min-height: 30px !important;\n}\n\n.css-tj5bde-Svg {\n  fill: var(--purple) !important;\n  height: 15px !important;\n  width: 15px !important;\n}\n\n.divCell .css-b62m3t-container .css-9e39r0-control {\n  border: none !important;\n  border-radius: 6px !important;\n  cursor: pointer;\n}\n\n.css-1u9des2-indicatorSeparator {\n  background-color: transparent !important;\n}\n\n.placeHolderStyle {\n  font-size: 12px !important;\n  color: var(--placeholder-grey) !important;\n  font-family: var(--inter-Regular);\n}\n\n.request-status-dropdown-container {\n  position: relative;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n}\n\n.request-status-dropdown-container img {\n  position: absolute;\n  top: 8px;\n  right: 9px;\n}\n\n.request-status-toast {\n  top: 28px !important;\n  width: 100px !important;\n}\n\n/* page not found styles**** */\n\n.dashboardContent.error-template .row {\n  background: var(--light-brown) !important;\n  height: 100vh;\n  padding: 0px !important;\n  margin: 0px !important;\n  width: 100%;\n  justify-content: center;\n}\n\n.region.region-content {\n  height: auto;\n  text-align: center;\n  box-shadow: 5px 7px 20px 0px #cccc;\n  margin: 4% 0px;\n  background: #ffffff54;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.dashboardContent.error-template img {\n  object-fit: scale-down;\n  width: 40%;\n}\n\n.dashboardContent.error-template .row .title {\n  color: var(--light-black);\n  font-family: var(--Inter-Bold700);\n  font-size: 34px;\n  line-height: 42px;\n  letter-spacing: -0.68px;\n}\n\n.content {\n  color: var(--table-text-color);\n  font-family: var(--Inter-SemiBold600);\n  font-size: 14px;\n  line-height: normal;\n  letter-spacing: 0.36px;\n  align-self: center;\n  word-break: break-all;\n  margin-right: 5px;\n  margin-top: 10px !important;\n}\n\n.dashboardContent.error-template .content.continue-program-text {\n  color: var(--purple);\n  text-decoration: none;\n  text-decoration: none;\n  word-break: break-all;\n  cursor: pointer;\n}\n\n.dashboardContent.error-template .content.continue-program-text:hover {\n  opacity: 0.8;\n}\n\n.divTable.manage-video-table .divCell {\n  word-break: break-word;\n  white-space: wrap;\n}\n\n.divTable.manage-video-table .divRow .divCell {\n  align-self: start;\n}\n\n.table-wrapper-container {\n  overflow-x: scroll;\n  max-width: 100%;\n  white-space: nowrap;\n  z-index: 9;\n  box-sizing: content-box;\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f0f0f0;\n}\n\n.table-wrapper-container::-webkit-scrollbar,\n.table-wrapper-container::-moz-scrollbar {\n  height: 8px;\n  border-radius: 10px;\n  background-color: #f1f1f1;\n}\n\n.table-wrapper-container::-webkit-scrollbar-thumb,\n.table-wrapper-container::-moz-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.table-wrapper-container::-webkit-scrollbar-thumb:hover,\n.table-wrapper-container::-moz-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* MEDIA QUERIES */\n@media (max-width: 1700px) {}\n\n@media (max-width: 768px) {\n  .main-container .main-sub-container .first-container-wrap {\n    display: none;\n    position: absolute;\n    top: 45px;\n    left: 0px;\n    width: 18.125rem;\n    z-index: 1001;\n    background-color: rgba(0, 0, 0, 0.1);\n    width: 100%;\n  }\n\n  .main-container .main-sub-container .first-container-wrap #sidebar {\n    height: calc(100vh - 45px) !important;\n  }\n\n  .hamburger-menu {\n    display: block;\n    z-index: 1001;\n  }\n\n  .main {\n    padding: 22px;\n  }\n\n  .footer-container {\n    width: 100% !important;\n    padding-right: 14px !important;\n  }\n\n  .auth-page-title,\n  .header .left-box>p:nth-child(2) {\n    font-size: 29px;\n    line-height: 29px;\n  }\n\n  .form-field-container {\n    width: 80% !important;\n    max-width: none;\n    padding-top: 40px !important;\n  }\n\n  .auth-page-wrapper .auth-container {\n    display: flex;\n    flex-direction: column-reverse !important;\n    justify-content: flex-end;\n  }\n\n  .auth-page-wrapper .auth-container .auth-col {\n    width: 100%;\n  }\n\n  .auth-page-wrapper .auth-container .auth-col-2 {\n    width: 100%;\n    padding-bottom: 80px;\n  }\n\n  .auth-page-wrapper .auth-container>div:nth-child(2) {\n    height: auto !important;\n    border-bottom-left-radius: 50px;\n  }\n\n  .auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {\n    width: 250px;\n    max-width: 250px;\n    height: auto;\n    margin: 35px;\n  }\n\n  .auth-container .auth-col .form-field-container {\n    width: 100% !important;\n    padding: 20px;\n  }\n\n  .wrapper {\n    height: auto !important;\n  }\n\n  .App {\n    height: 100%;\n    background: white;\n  }\n}\n\n@media (max-width: 440px) {\n  .header {\n    flex-direction: column !important;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n\n  .header .left-box {\n    margin-bottom: 19px;\n  }\n\n  .auth-page-title,\n  .header .left-box>p:nth-child(2) {\n    font-size: 25px;\n    line-height: 25px;\n  }\n\n  .main {\n    padding: 16px;\n  }\n\n  .coach-header .left-box>p:nth-child(1) {\n    font-size: 19px !important;\n    line-height: 19px !important;\n  }\n\n  .header .right-box {\n    justify-content: flex-end;\n  }\n\n  .paginatino-button {\n    display: none;\n  }\n\n  .modal-footer button,\n  .options-container .deleteButton {\n    width: 100% !important;\n  }\n\n  .form-field-container {\n    width: 100% !important;\n    margin-bottom: 20px;\n  }\n\n  .auth-container .auth-col .form-field-container {\n    width: 100% !important;\n    padding: 20px 15px;\n    padding-bottom: 0px;\n  }\n\n  .auth-page-wrapper .auth-container>div:nth-child(2) .logo-container {\n    width: 200px;\n    max-width: 200px;\n    height: auto;\n    margin: 50px;\n  }\n\n  #second-container-wrap .header .left-box {\n    margin-bottom: 0px !important;\n  }\n\n  #second-container-wrap .header .right-box {\n    position: fixed;\n    top: 3px;\n    right: 12px;\n    z-index: 22;\n  }\n\n  #second-container-wrap .header.coach-header .right-box {\n    position: relative;\n    margin-top: 15px;\n    right: 0px !important;\n  }\n\n  #sidebar {\n    width: 16rem !important;\n  }\n\n  #sidebar>* {\n    padding-left: 1rem !important;\n  }\n\n  .dashboardContent.error-template .col-lg-3 {\n    display: none;\n  }\n\n  .dashboardContent.error-template img {\n    width: 60%;\n  }\n\n  .dashboardContent.error-template .col-lg-6.region.region-content {\n    margin: 25px;\n    /* height: auto !important; */\n  }\n}\n\n/* modal width media Queries */\n\n@media (min-width: 768px) {\n\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 700px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
